import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * "Octo ile ___ siz kurgularsınız" — boşluktaki sözcük birkaç saniyede bir değişir.
 *
 * Octo tek bir sektörün ürünü değil, üstüne kurulan bir platform: sabit bir cümle
 * ("üretimden kaliteye" gibi) onu olduğundan dar gösteriyordu. Dönen sözcük, ekranların
 * da süreçlerin de raporların da kullanıcının elinde olduğunu tek satırda anlatıyor.
 *
 * Hareket azaltma tercihinde dönüş durur; ilk sözcük sabit kalır — cümle yine tamdır.
 */
export function RotatingWord({ intervalMs = 2600 }: { intervalMs?: number }) {
  const { t } = useTranslation();
  const words = t('auth.rotating.words', { returnObjects: true }) as unknown;
  const list = Array.isArray(words) && words.length > 0 ? (words as string[]) : [];
  const [i, setI] = useState(0);

  const reduced =
    typeof window !== 'undefined' && typeof window.matchMedia === 'function'
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;

  useEffect(() => {
    if (reduced || list.length < 2) return;
    const id = setInterval(() => setI((v) => (v + 1) % list.length), intervalMs);
    return () => clearInterval(id);
  }, [reduced, list.length, intervalMs]);

  if (list.length === 0) return null;
  const tail = t('auth.rotating.tail');

  return (
    <p className="text-fg-muted text-sm">
      {t('auth.rotating.lead')}{' '}
      {/* Sözcük değişince satır uzunluğu değişiyor; kutu satır içinde kalır ki
          çevresindeki metin zıplamasın, yalnızca sözcük yerinde solup belirsin. */}
      <span
        key={list[i % list.length]}
        className="octo-rise text-brand-600 inline-block font-medium"
        style={{ animationDuration: '.35s' }}
      >
        {list[i % list.length]}
      </span>
      {tail ? ` ${tail}` : ''}
    </p>
  );
}
